import React, { useEffect, useState } from 'react';
import { TextFieldv2 } from 'ui-component/formComponents';
import { InputAdornment } from '@mui/material';

interface RenderCurrencyFieldProps {
    value: any;
    onChange: (value: any) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const RenderCurrencyField = ({ value, onChange, onBlur }: RenderCurrencyFieldProps) => {
    const formatValue = (val: any) => {
        if (val !== '' && !isNaN(Number(val))) {
            return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(val));
        }
        return val ?? '';
    };
    const [inputValue, setInputValue] = useState(() => formatValue(value));
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (!isEditing) {
            setInputValue(formatValue(value));
        }
    }, [value, isEditing]);

    return (
        <TextFieldv2
            type="text"
            InputProps={{
                startAdornment: (
                    <InputAdornment
                        position="start"
                        sx={{
                            mt: 0,
                            '& > p': { fontSize: '10px', transform: 'translateY(-5px)' }
                        }}
                    >
                        USD
                    </InputAdornment>
                )
            }}
            value={inputValue}
            onChange={(e) => {
                const val = e.target.value;
                setInputValue(val);
                setIsEditing(true);

                // Permitir cualquier entrada durante la edición
                if (val === '' || /^\d*\.?\d*$/.test(val)) {
                    onChange(val === '' ? '' : Number(val));
                }
            }}
            onFocus={() => {
                setIsEditing(true);
                // Mostrar el valor sin formato cuando el usuario comienza a editar
                const numericValue = inputValue.replace(/,/g, '');
                setInputValue(numericValue);
            }}
            onBlur={(e) => {
                setIsEditing(false);
                let val = e.target.value.replace(/,/g, '');

                if (val !== '' && !isNaN(Number(val))) {
                    val = Number(val).toFixed(2);
                    const formattedValue = new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(Number(val));

                    setInputValue(formattedValue);
                    onChange(Number(val));
                } else if (val === '') {
                    setInputValue('');
                    onChange('');
                }

                if (onBlur) onBlur(e);
            }}
        />
    );
};
